module.exports = __webpack_public_path__ + "479970ffb74f2117317f9d24d9e317fe.woff2";


//////////////////
// WEBPACK FOOTER
// ./application/font/Roboto-Regular.woff2
// module id = 348
// module chunks = 0